<template>
  <div v-loading="loading">
    <page-heading
      heading="Диапазоны"
    >
      <div slot="right">
        <div class="el-row--flex">
          <el-button
            style="margin-left: 20px"
            type="primary"
            size="small"
            icon="fas fa-plus"
            @click="rangeCreate"
          >
            Создать диапазон
          </el-button>
        </div>
      </div>
    </page-heading>
    <div>
      <el-card
        v-for="range in ranges"
        :key="range.id"
        class="template-card"
        style="margin-bottom: 35px"
      >
        <range-recommendations
          :range.sync="range"
          @range-update="getRanges"
        ></range-recommendations>
      </el-card>
    </div>
  </div>
</template>

<script>
import PageHeading from "@/components/PageHeading.vue";
import RangeRecommendations from "@/modules/evaluation/components/recommendation/RangeRecommendations.vue";

export default {
  name: "ranges-recommendation",
  components: {RangeRecommendations, PageHeading},
  data() {
    return {
      loading: false,
      ranges: [],
    }
  },
  mounted() {
    this.getRanges();
  },
  methods: {
    getRanges() {
      this.loading = true;
      this.$api.evaluation.rangeSearch({
        competence_id: this.$route.params.id,
        expand: ['recommendations'].join(),
      })
        .then(({data}) => {
          this.ranges = data.ranges;
        })
        .finally(() => {
          this.loading = false;
        })
    },
    rangeCreate() {
      this.loading = true;
      this.$api.evaluation.rangeCreate({
        competence_id: this.$route.params.id,
      })
        .then(({data}) => {
          this.$notify.success({
            title: 'Сохранено',
            message: 'Диапазон успешно создан'
          });
          this.getRanges();
        });
    },
  }
}
</script>

<style>

</style>